import React, { useEffect } from 'react'
import { TextInput } from '@paypalcorp/pp-react'
import { trackClick, trackFormValidationClick } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'

const TextInputAdapter = ({ input, meta, fptiPage, ...rest }) => {
  const handleFocus = () => {
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
      event_name: FPTI_EVENTS.FORM.FIELD_PRESSED,
    })
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackFormValidationClick({
        page: fptiPage,
        message: meta.error,
        component: input.name,
        link: input.name,
        event_name: FPTI_EVENTS.FORM.VALIDATION_ERROR,
      })
    }
  }, [meta.error, meta.touched])

  return (
    <TextInput
      {...input}
      {...rest}
      onChange={(event) => input.onChange(event.target.value)}
      onFocus={handleFocus}
      errorText={meta.touched ? meta.error : ''}
    />
  )
}

export default TextInputAdapter
